import { useState } from "react";
import { characterFilters, characters } from "@/mocks/content";
import { Reveal, SectionHeading } from "./common";

export default function Characters() {
  const [filter, setFilter] = useState(characterFilters[0]);
  const list =
    filter === characterFilters[0]
      ? characters
      : characters.filter((c) => c.category === filter);

  return (
    <section id="characters" className="section-anchor w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="角色介绍"
            title="每个角色，都替故事承担了一种情绪"
            desc="善良的嫂子角色介绍并非简单罗列，而是理解剧情走向的钥匙。下列角色按其在故事中的功能分类，可切换查看。"
          />
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-6 inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-50 border border-background-200">
            {characterFilters.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => setFilter(item)}
                aria-pressed={filter === item}
                className={`px-4 md:px-6 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  filter === item
                    ? "bg-accent-500 text-background-50"
                    : "text-foreground-700 hover:text-accent-700"
                }`}
              >
                {item}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6">
          {list.map((char) => (
            <Reveal key={char.id} delay={60}>
              <article className="h-full flex flex-col rounded-lg bg-background-50 border border-background-200 overflow-hidden">
                <div className="relative w-full aspect-[4/5] bg-background-200">
                  <img
                    src={char.avatar}
                    alt={`${char.name}——善良的嫂子角色介绍`}
                    title={`${char.name} 角色介绍`}
                    className="w-full h-full object-cover object-top"
                  />
                  <span className="absolute top-3 left-3 text-[11px] px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800">
                    {char.category}
                  </span>
                </div>
                <div className="flex-1 flex flex-col p-5">
                  <div className="flex items-baseline gap-2">
                    <h3 className="font-heading text-lg font-bold text-foreground-950">{char.name}</h3>
                    <span className="text-xs text-foreground-500">{char.role}</span>
                  </div>

                  <div className="mt-3 flex flex-wrap gap-1.5">
                    {char.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>

                  <p className="mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {char.summary}
                  </p>

                  <div className="mt-4 pt-4 border-t border-background-200">
                    <p className="text-xs font-label text-foreground-500 mb-2">性格关键词</p>
                    <ul className="flex flex-wrap gap-2">
                      {char.traits.map((t) => (
                        <li
                          key={t}
                          className="text-[11px] px-2 py-1 rounded-md bg-background-100 text-foreground-700"
                        >
                          {t}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mt-4 rounded-md bg-primary-50 border border-primary-200 p-3">
                    <p className="text-[11px] font-label text-primary-700 mb-1">人物弧光</p>
                    <p className="text-xs text-foreground-700 leading-relaxed">{char.arc}</p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}